import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import currencyService from "../../services/currencyService";

export const fetchCurrencies = createAsyncThunk(
  "currencies/fetchActive",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await currencyService.listActive();
      return data.data.currencies;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

const currenciesSlice = createSlice({
  name: "currencies",
  initialState: {
    list: [],
    loaded: false,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrencies.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCurrencies.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loaded = true;
        state.loading = false;
      })
      .addCase(fetchCurrencies.rejected, (state) => {
        state.loading = false;
      });
  },
});

// ["USD", "CAD", ...] — falls back to USD alone if not loaded yet, so a
// dropdown never renders with zero options.
export const selectCurrencyOptions = (state) =>
  state.currencies.list.length > 0 ? state.currencies.list.map((c) => c.code) : ["USD"];

export default currenciesSlice.reducer;
